import { ComponentType } from "preact";
import render from "preact-render-to-string";
import {
    ActivityBox,
    Button,
    DayBox,
    Icon,
    StyledText,
    Tooltip,
} from "./templates";

const TEMPLATES: Partial<Record<string, ComponentType>> = {
    "day-box": DayBox,
    "activity-box": ActivityBox,
    button: Button,
    "styled-text": StyledText,
    tooltip: Tooltip,
    icon: Icon,
};

export const renderTemplate = (
    name: string,
    props: Partial<Record<string, string>>,
): string | null => {
    const Comp = TEMPLATES[name];

    if (!Comp) {
        return null;
    }

    return render(<Comp {...props} />);
};
